import React, { FC } from "react";
import { useFormikContext } from "formik";
import { ExecuteReportValues } from "shared/types";
import { Form, Select, DatePicker, InputNumber } from "antd";
import dayjs, { Dayjs } from "dayjs";

const { Option } = Select;

interface DriggingRiggFilterProps {}

export const DriggingRiggFilter: FC<DriggingRiggFilterProps> = () => {
  const { values, setFieldValue } = useFormikContext<ExecuteReportValues>();

  const handleDateChange = (
    field: keyof ExecuteReportValues,
    val: Dayjs | null
  ) => {
    setFieldValue(field, val ? val.toISOString() : null);
  };

  return (
    <div className="flex flex-col gap-y-2 max-w-3xl">
      <Form layout="vertical">
        <div className="flex mt-4 gap-5">
          <Form.Item label="Start DateTime" required>
            <DatePicker
              showTime
              value={
                values.drigging_rigg_datetime_start
                  ? dayjs(values.drigging_rigg_datetime_start)
                  : null
              }
              onChange={(val) =>
                handleDateChange("drigging_rigg_datetime_start", val)
              }
              onOk={(val) =>
                handleDateChange("drigging_rigg_datetime_start", val)
              }
            />
          </Form.Item>

          <Form.Item className="max-w-[249px]" label="End DateTime" required>
            <DatePicker
              showTime
              value={
                values.drigging_rigg_datetime_end
                  ? dayjs(values.drigging_rigg_datetime_end)
                  : null
              }
              onChange={(val) =>
                handleDateChange("drigging_rigg_datetime_end", val)
              }
              onOk={(val) =>
                handleDateChange("drigging_rigg_datetime_end", val)
              }
            />
          </Form.Item>
        </div>

        <div className="flex gap-5 mt-4">
          <Form.Item className="max-w-[249px] w-full" label="Field" required>
            <Select
              value={values.drigging_rigg_field}
              onChange={(val) => setFieldValue("drigging_rigg_field", val)}
            >
              <Option value="ozone2_extruder2">ozone2_extruder2</Option>
            </Select>
          </Form.Item>

          <Form.Item
            className="max-w-[249px] w-full"
            label="Number of Points"
            required
          >
            <InputNumber
              min={1}
              value={values.drigging_rigg_n_points}
              onChange={(val) => setFieldValue("drigging_rigg_n_points", val)}
            />
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};
